<template>
  <!-- v-show="!noNav" -->
  <div
    class="g-breadcrumb"
    :style="$route.path == '/nineGridShare' ? 'padding: 15px 0;' : 'padding: 15px 20px;'"
  >
    <div class="breadcrumb-title">
      <div
        class="title-start"
        :class="{ 'title-start-before': $route.path !== '/homePage' }"
        :style="$route.path == '/homePage' ? 'cursor: auto;' : ''"
        @click="goHomePage"
      >
        {{ $route.path == "/homePage" ? "首页" : "首页" }}
      </div>
      <div
        class="title-mid"
        :style="$route.path == '/homePage' ? 'color: #222; font-weight: bold;' : ''"
      >
        {{ $route.path == "/homePage" ? "-" : ">>" }}
      </div>
      <div
        class="title-end"
        :style="$route.path == '/homePage' ? 'color: #222; font-weight: bold; cursor: auto;' : ''"
      >
        {{ secondaryName }}
      </div>
    </div>
    <div
      v-if="maintainStatus == 1"
      class="maintainWarning"
    >
      <span>温馨提示：</span>
      为提供更好产品体验，{{ maintainDate }}
      平台维护例行维护，届时标源交易暂时无法使用，由此带来不便，敬请谅解！
    </div>
    <div
      v-if="$route.path != '/homePage'"
      class="breadcrumb-back"
      @click="routerFadeBack"
    >
      返回>>
    </div>
  </div>
</template>

<script>
/**
 * 面包屑组件
 */
import { mapState } from "vuex";
export default {
  props: {},
  data() {
    return {
      separatorPayload: "-",
      secondaryName: "专利交易中心",
      noNav: false,
      fromHomeMap: [
        "/patentManage",
        "/messageList"
      ], // 定义返回Home特定路由, 不然默认都返回到上一级
      fromReleaseMap: [
        "/patentRelease",
        "/releaseRecord"
      ], // 发布特定返回
    };
  },
  computed: {
    ...mapState("maintainInfo", {
      maintainStatus: state => state.maintainStatus,
      maintainDate: state => state.maintainDate
    }),
    ...mapState("userInfo", {
      userInfo: state => state.QDS_LOGIN_INFO_OFFICE,
      hasLoginInfo: state => state.hasLoginInfo,
      agentInfo: state => state.agentInfo,
      partnerType: state => state.partnerType,
      hasUserInfo: state => state.hasLoginInfo,
      isClient: state => state.isClient,
      rolePermissionList: state => state.rolePermissionList,
    }),
  },
  watch: {
    $route: {
      handler() {
        this.secondaryName = (this.$route.meta && this.$route.meta.breadCrumbName) || "默认路由";
        this.noNav = (this.$route.meta && this.$route.meta.isNoNav) || false;
        setTimeout(() => {
          this.$route.meta.isNoNav = this.maintainStatus == 0 ? true : false;
        }, 0);
      },
      immediate: true
    }
  },
  methods: {
    // 返回首页
    goHomePage() {
      if (this.$route.path == "/homePage") return;
      this.$router.push({path: '/homePage', query :{fromPath: this.isClient==1 ? 'qdsClient' : 'PC'}});
    },
    // 返回
    routerFadeBack() {
      if (this.fromHomeMap.includes(this.$route.path)) {
        this.$router.push({path: '/homePage', query :{fromPath: this.isClient==1 ? 'qdsClient' : 'PC'}});
      } else if (this.fromReleaseMap.includes(this.$route.path)) {
        this.$router.push({path: '/patentManage', query :{fromPath: this.isClient==1 ? 'qdsClient' : 'PC'}});
      } else {
        if (this.$route.path == "/brandInfo" || this.$route.path == "/nineGridShare") {
          this.$router.push({path: '/patentList', query :{fromPath: this.isClient==1 ? 'qdsClient' : 'PC'}});
        } else {
          this.$router.go(-1);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.g-breadcrumb {
  width: 100%;
  min-width: 1280px;
  background-color: #fff;
  padding: 15px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  // ::v-deep .el-breadcrumb__inner {
  //   font-weight: bold;
  //   font-size: $font-size-medium;
  //   color: #000;
  // }
  // ::v-deep .el-breadcrumb__separator {
  //   font-weight: bold;
  //   font-size: $font-size-medium;
  //   color: #000;
  //   margin: 0 4px;
  // }
  .breadcrumb-title {
    position: relative;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    .title-start {
      cursor: pointer;
      color: #222;
      font-weight: bold;
    }
    .title-start-before {
      padding-left: 12px;
    }
    .title-start-before::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0px;
      width: 4px;
      height: 14px;
      background-color: #ff7200;
      border-radius: 2px;
    }
    .title-mid {
      margin: 0 5px;
    }
    .title-end {
      cursor: pointer;
      color: #666;
    }
  }
  .maintainWarning {
    margin-left: 15px;
    font-size: 12px;
    padding: 10px;
    background: #fff1e5;
    color: #666666;
    span {
      color: #ff7200;
    }
  }
  .breadcrumb-back {
    font-size: 14px;
    color: #999;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>